"use client";

import { c as _c } from "react/compiler-runtime";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { usePageTransition } from "@/components/page-transition-provider";
import { scrollToSection } from "@/lib/scroll-to-section";
import { cn } from "@/lib/utils";
import type { HeroAction } from "./types";
type HeroActionsProps = {
  actions?: HeroAction[];
  hideProjectsActionOnMobile?: boolean;
};
export function HeroActions(t0) {
  const $ = _c(9);
  const {
    actions,
    hideProjectsActionOnMobile: t1
  } = t0;
  const hideProjectsActionOnMobile = t1 === undefined ? false : t1;
  const {
    navigate
  } = usePageTransition();
  if (!actions || actions.length === 0) {
    return null;
  }
  let t2;
  if ($[0] !== actions || $[1] !== hideProjectsActionOnMobile || $[2] !== navigate) {
    let t3;
    if ($[4] !== hideProjectsActionOnMobile || $[5] !== navigate) {
      t3 = action => <ButtonRadialFill className={cn("h-14.5 w-full md:w-auto px-6 rounded-2xl border max-sm:max-w-fit whitespace-nowrap max-md:text-sm", action.variant === "primary" ? "border-primary-300 bg-primary-300" : "border-gray-200 bg-transparent", hideProjectsActionOnMobile && action.label === "Ver projetos" ? "max-md:hidden" : null)} classNameFill={action.variant === "primary" ? "bg-gray-1100" : "bg-gray-1000"} key={`${action.href}-${action.label}`} onClick={event => {
        if (action.href.startsWith("#") && scrollToSection(action.href)) {
          return;
        }
        navigate(action.href, {
          origin: {
            x: event.clientX,
            y: event.clientY
          }
        });
      }}>{action.label}</ButtonRadialFill>;
      $[4] = hideProjectsActionOnMobile;
      $[5] = navigate;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = actions.slice(0, 2).map(t3);
    $[0] = actions;
    $[1] = hideProjectsActionOnMobile;
    $[2] = navigate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="hero-webpart-actions mt-8 lg:mt-15 flex gap-4">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}